/**
 * This file is auto-generated by 'scripts/generate-image-formats.ts' from '@eneco/cms-sanity-schema'
 * (image-formats.json). Do not manually edit; your changes might get lost.
 */
import type { ImageFormatsTable } from './image-formats';

export const IMAGE_FORMATS_TABLE: ImageFormatsTable = {
  version: 1,
  fields: [
    { sanityType: 'AccountInviteForm', field: 'welcomeScreenHeaderImage', group: 'image1by1' },
    { sanityType: 'Article', field: 'image', group: 'Article' },
    { sanityType: 'articlePage', field: 'image', group: 'Card' },
    { sanityType: 'BundleFlowOfferItem', field: 'image', group: 'Flow/DongleFlow/OfferStep' },
    { sanityType: 'ContactFormDeflection', field: 'answerImage', group: 'image1by1' },
    { sanityType: 'ContactMethods', field: 'image', group: 'image1by1' },
    { sanityType: 'ContentCard', field: 'image', group: 'Card' },
    { sanityType: 'ContentCardRebranded', field: 'image', group: 'image4by3' },
    { sanityType: 'ContentCardRedesigned', field: 'image', group: 'Card' },
    { sanityType: 'DashboardOverview', field: 'anticipationAnnouncementCard_image', group: 'image1by1' },
    { sanityType: 'DashboardOverview', field: 'deliveryCountdownCard_image', group: 'image1by1' },
    { sanityType: 'DashboardOverview', field: 'electricityImage', group: 'image1by1' },
    { sanityType: 'DashboardOverview', field: 'gasImage', group: 'image1by1' },
    { sanityType: 'DashboardOverview', field: 'moveFileCreatedCard_image', group: 'image1by1' },
    { sanityType: 'DashboardOverview', field: 'thankYouCard_image', group: 'image1by1' },
    { sanityType: 'DecarbonizationPotentialBreakdown', field: 'content_image', group: 'Hero' },
    { sanityType: 'DecarbonizationPotentialBreakdown', field: 'noResultsOutcome_image', group: 'image4by3' },
    { sanityType: 'DongleFlowOfferItem', field: 'image', group: 'Flow/DongleFlow/OfferStep' },
    { sanityType: 'DongleFlowOfferStep', field: 'image', group: 'Flow/DongleFlow/OfferStep' },
    { sanityType: 'DongleOnboardingFlow', field: 'alreadyConnectedImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'awaitingPortActivationImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'bluetoothFailureImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'errorImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'fluviusInstructionImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'getStartedDongleImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'onboardingInstructionsImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'portActivationApprovalImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'portActivationConfirmationImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'portActivationConfirmationNotificationImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'portActivationSuccessImage', group: 'image1by1' },
    { sanityType: 'DongleOnboardingFlow', field: 'successImage', group: 'image1by1' },
    { sanityType: 'ErrorMessage', field: 'errorMessageImage', group: 'image1by1' },
    { sanityType: 'FeaturedBanner', field: 'featuredBannerImage', group: 'Card' },
    { sanityType: 'FeaturePreviewItem', field: 'image', group: 'FeaturePreview' },
    { sanityType: 'FlowThankYouHero', field: 'image', group: 'FlowThankYouHero' },
    { sanityType: 'FluviusFlow', field: 'failureImage', group: 'image1by1' },
    { sanityType: 'FluviusFlowItem', field: 'image', group: 'image1by1' },
    { sanityType: 'ForgotEmail', field: 'initialScreenWhereToFindCustomerNumberImage', group: 'image1by1' },
    { sanityType: 'ForgotEmailConfirmed', field: 'image', group: 'image16by9' },
    { sanityType: 'GenericCheckboxChoiceStep', field: 'image', group: 'Flow/base' },
    { sanityType: 'GenericChoiceStep', field: 'image', group: 'Flow/base' },
    { sanityType: 'GenericRadioChoiceStep', field: 'image', group: 'Flow/base' },
    { sanityType: 'Hero', field: 'image', group: 'Hero' },
    { sanityType: 'HeroRebranded', field: 'image', group: 'Hero' },
    { sanityType: 'Image', field: 'image', group: 'image16by9', when: { aspectRatio: '16:9' } },
    { sanityType: 'Image', field: 'image', group: 'image1by1', when: { aspectRatio: '1:1' } },
    { sanityType: 'Image', field: 'image', group: 'image4by3', when: { aspectRatio: '4:3' } },
    { sanityType: 'InspirationAdviceFilterAdviceCard', field: 'focalImage', group: 'InspirationAdviceFilter' },
    { sanityType: 'LatestYearNoteDownloadCard', field: 'image', group: 'Card' },
    { sanityType: 'LegendInfoItem', field: 'image', group: 'image1by1' },
    { sanityType: 'LogInStep', field: 'image', group: 'Flow/base/LoginStep' },
    { sanityType: 'MoveOnboarding', field: 'headerImage', group: 'image1by1' },
    { sanityType: 'myEnecoLandingPage', field: 'backgroundImage', group: 'LandingPage' },
    { sanityType: 'MyEnecoProduct', field: 'image', group: 'image1by1' },
    { sanityType: 'MyEnecoUpcomingYearlyInvoice', field: 'image', group: 'image1by1' },
    { sanityType: 'myOxxioFullWidth', field: 'backgroundImage', group: 'LandingPage' },
    { sanityType: 'NativeUsage', field: 'dongleBeingDeliveredBannerImage', group: 'image16by9' },
    { sanityType: 'NativeUsage', field: 'premiumBannerImage', group: 'image16by9' },
    { sanityType: 'NativeUsage', field: 'reactivatePremiumBannerImage', group: 'image16by9' },
    { sanityType: 'NonCommodityProduct', field: 'image', group: 'ShopWindow' },
    { sanityType: 'OrderManagement', field: 'contactCardImage', group: 'image1by1' },
    { sanityType: 'PaymentArrangementEndStep', field: 'image', group: 'image4by3' },
    { sanityType: 'PopupImage', field: 'image', group: 'image16by9' },
    { sanityType: 'PremiumServiceBanner', field: 'productImage', group: 'image1by1' },
    { sanityType: 'PriceSimulation', field: 'promoDiscountImage', group: 'image1by1' },
    { sanityType: 'productPage', field: 'image', group: 'Card' },
    { sanityType: 'ProductPurchaseFlow', field: 'dongleAlreadyPurchasedImage', group: 'image1by1' },
    { sanityType: 'ProductPurchaseResult', field: 'resultImage', group: 'image1by1' },
    { sanityType: 'ProductSwitch', field: 'image', group: 'image1by1' },
    { sanityType: 'ProspectCta', field: 'customerImage', group: 'image1by1' },
    { sanityType: 'ProspectCta', field: 'prospectImage', group: 'image1by1' },
    { sanityType: 'RentalDevicesDetectionStep', field: 'image', group: 'RentalDeviceFlow/RentalDevicesDetectionStep' },
    { sanityType: 'ReportProblem', field: 'successImage', group: 'image1by1' },
    { sanityType: 'ServiceGemakFlowContact', field: 'image', group: 'Flow/ServiceGemakFlow/ServiceGemakFlowContact' },
    { sanityType: 'siteWideBundleFlowOfferItem', field: 'image', group: 'Flow/DongleFlow/OfferStep' },
    { sanityType: 'siteWideDongleFlowOfferItem', field: 'image', group: 'Flow/DongleFlow/OfferStep' },
    { sanityType: 'siteWideNonCommodityProduct', field: 'image', group: 'ShopWindow' },
    { sanityType: 'siteWideStepExplainerItem', field: 'image', group: 'image4by3' },
    { sanityType: 'siteWideToonProduct', field: 'image', group: 'ShopWindow' },
    { sanityType: 'SmartChargingCompatibilityCheckResult', field: 'resultImage', group: 'image1by1' },
    { sanityType: 'SmartTargetingBanner', field: 'image', group: 'image1by1' },
    { sanityType: 'SmeOfferStep', field: 'thankYouImage', group: 'image4by3' },
    { sanityType: 'StepExplainerItem', field: 'image', group: 'image4by3' },
    { sanityType: 'TextImageRebranded', field: 'image', group: 'image4by3' },
    { sanityType: 'ThermostatFlowOfferStep', field: 'image', group: 'Flow/ThermostatFlow/OfferStep' },
    { sanityType: 'ThermostatFlowOverviewStep', field: 'image', group: 'Flow/ThermostatFlow/OverviewStep' },
    { sanityType: 'ToonProduct', field: 'image', group: 'ShopWindow' },
    { sanityType: 'TutorialItem', field: 'image', group: 'image1by1' },
    { sanityType: 'WeDoenHetNuTestimonialsCard', field: 'image', group: 'image1by1' },
    { sanityType: 'WeDoenHetNuTestimonialsCard', field: 'image', group: 'image4by3' },
    { sanityType: 'WeDoenHetNuTextImage', field: 'image', group: 'image4by3' },
    { sanityType: 'WelcomePage', field: 'image', group: 'image16by9' },
    { sanityType: 'WieDoetErMeeContentCard', field: 'image', group: 'image1by1' },
  ],
  sites: {
    'eneco-be': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      Hero: [
        { format: 'default', width: 440, height: 280 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
    },
    'eneco-be-business': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      Hero: [
        { format: 'default', width: 440, height: 280 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
    },
    'eneco-be-kmo': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      Hero: [
        { format: 'default', width: 440, height: 280 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
    },
    'eneco-co-uk': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
      InspirationAdviceFilter: [
        { format: 'default', width: 720, height: 540 },
        { format: 'widescreen', width: 720, height: 405 },
      ],
      ShopWindow: [{ format: 'default', width: 650, height: 400 }],
    },
    'eneco-de': {
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
    },
    'eneco-nl': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      ContentHub: [{ format: 'default', width: 1696, height: 960 }],
      FeaturePreview: [
        { format: 'default', width: 320, height: 230 },
        { format: 'large', width: 800, height: 600 },
        { format: 'small', width: 320, height: 230 },
      ],
      Flow: [{ format: 'default', width: 1696, height: 960 }],
      'Flow/base': [{ format: 'default', width: 1440, height: 810 }],
      'Flow/base/LoginStep': [{ format: 'default', width: 1440, height: 810 }],
      'Flow/DongleFlow/OfferStep': [{ format: 'default', width: 1440, height: 810 }],
      'Flow/ServiceGemakFlow/ServiceGemakFlowContact': [{ format: 'default', width: 300, height: 300 }],
      'Flow/ThermostatFlow/OfferStep': [{ format: 'default', width: 1440, height: 810 }],
      'Flow/ThermostatFlow/OverviewStep': [{ format: 'default', width: 1440, height: 810 }],
      FlowThankYouHero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      'HeatPumpSuitabilityCheckFlow/HeatPumpOutdoorUnitStep': [{ format: 'default', width: 1696, height: 960 }],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
      InspirationAdviceFilter: [
        { format: 'default', width: 720, height: 540 },
        { format: 'widescreen', width: 720, height: 405 },
      ],
      LandingPage: [
        { format: 'default', width: 2430, height: 1621 },
        { format: 'mobile', width: 1080, height: 720 },
      ],
      'LeadFlow/AddressStep': [{ format: 'default', width: 1308, height: 768 }],
      'LeadFlow/ConfirmationStep': [{ format: 'default', width: 1696, height: 960 }],
      'LeadFlow/Pluimers': [{ format: 'default', width: 1554, height: 408 }],
      'LeadFlow/ProductSelectionStep': [{ format: 'default', width: 1696, height: 960 }],
      'LeadFlow/SummaryStep': [{ format: 'default', width: 1696, height: 960 }],
      'QuoteApprovalFlow/Footer': [{ format: 'default', width: 149, height: 149 }],
      'QuoteApprovalFlow/NoProductSelectedStep': [{ format: 'default', width: 1697, height: 960 }],
      'QuoteApprovalFlow/SolarPanel': [{ format: 'default', width: 1024, height: 576 }],
      'QuoteApprovalFlow/StartStep': [{ format: 'default', width: 1696, height: 960 }],
      'QuoteApprovalFlow/SummaryStep': [{ format: 'default', width: 1696, height: 960 }],
      ShopWindow: [
        { format: 'default', width: 650, height: 400 },
        { format: 'small', width: 768, height: 432 },
      ],
    },
    'eneco-nl-grootzakelijk': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      FeaturePreview: [
        { format: 'default', width: 320, height: 230 },
        { format: 'large', width: 800, height: 600 },
        { format: 'small', width: 320, height: 230 },
      ],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
      InspirationAdviceFilter: [
        { format: 'default', width: 720, height: 540 },
        { format: 'widescreen', width: 720, height: 405 },
      ],
      ShopWindow: [{ format: 'default', width: 650, height: 400 }],
    },
    'eneco-nl-mkb': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      FeaturePreview: [
        { format: 'default', width: 320, height: 230 },
        { format: 'large', width: 800, height: 600 },
        { format: 'small', width: 320, height: 230 },
      ],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 768, height: 768 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
      InspirationAdviceFilter: [
        { format: 'default', width: 720, height: 540 },
        { format: 'widescreen', width: 720, height: 405 },
      ],
      'LeadFlow/ProductSelectionStep': [{ format: 'default', width: 1696, height: 960 }],
      'LeadFlow/SummaryStep': [{ format: 'default', width: 1696, height: 960 }],
      ShopWindow: [{ format: 'default', width: 650, height: 400 }],
    },
    'eneco-nl-over-ons': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
      InspirationAdviceFilter: [
        { format: 'default', width: 720, height: 540 },
        { format: 'widescreen', width: 720, height: 405 },
      ],
      'LeadFlow/ProductSelectionStep': [{ format: 'default', width: 1696, height: 960 }],
      'LeadFlow/SummaryStep': [{ format: 'default', width: 1696, height: 960 }],
      ShopWindow: [{ format: 'default', width: 650, height: 400 }],
    },
    'eneco-nl-zakelijk': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [
        { format: 'default', width: 650, height: 400 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      FeaturePreview: [
        { format: 'default', width: 320, height: 230 },
        { format: 'large', width: 800, height: 600 },
        { format: 'small', width: 320, height: 230 },
      ],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
      InspirationAdviceFilter: [
        { format: 'default', width: 720, height: 540 },
        { format: 'widescreen', width: 720, height: 405 },
      ],
      ShopWindow: [{ format: 'default', width: 650, height: 400 }],
    },
    'oxxio-nl': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [{ format: 'default', width: 650, height: 400 }],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      FeaturePreview: [
        { format: 'default', width: 320, height: 230 },
        { format: 'large', width: 800, height: 600 },
        { format: 'small', width: 320, height: 230 },
      ],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 738, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
    },
    'woonenergie-nl': {
      Article: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      Card: [{ format: 'default', width: 650, height: 400 }],
      ContentCard: [{ format: 'default', width: 650, height: 400 }],
      FeaturePreview: [
        { format: 'default', width: 320, height: 230 },
        { format: 'large', width: 800, height: 600 },
        { format: 'small', width: 320, height: 230 },
      ],
      Hero: [
        { format: 'default', width: 1024, height: 460 },
        { format: 'large', width: 1920, height: 640 },
        { format: 'small', width: 1024, height: 460 },
      ],
      image16by9: [
        { format: 'default', width: 768, height: 432 },
        { format: 'extraLarge', width: 1024, height: 576 },
        { format: 'large', width: 1024, height: 576 },
        { format: 'medium', width: 1024, height: 576 },
        { format: 'small', width: 768, height: 432 },
      ],
      image1by1: [
        { format: 'default', width: 748, height: 748 },
        { format: 'extraLarge', width: 1024, height: 1024 },
        { format: 'large', width: 1024, height: 1024 },
        { format: 'medium', width: 1024, height: 1024 },
        { format: 'small', width: 748, height: 748 },
      ],
      image4by3: [
        { format: 'default', width: 768, height: 576 },
        { format: 'extraLarge', width: 1024, height: 768 },
        { format: 'large', width: 1024, height: 768 },
        { format: 'medium', width: 1024, height: 768 },
        { format: 'small', width: 768, height: 576 },
      ],
    },
  },
};
